
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sifremi-unuttum",
      function () {
        return require("private-next-pages/sifremi-unuttum.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sifremi-unuttum"])
      });
    }
  